import { Link } from "react-router-dom";

const getCategoryBadge = (category) => {
  const badges = {
    "sci-fi": "badge-scifi",
    "fantasy": "badge-fantasy",
    "superhero": "badge-superhero",
    "horror": "badge-horror",
  };
  return badges[category] || "badge-scifi";
};

const UniverseCard = ({ universe }) => {
  return (
    <Link 
      to={`/universe/${universe.slug}`}
      className="group block card-surface overflow-hidden"
      data-testid={`universe-card-${universe.slug}`}
    >
      {/* Image */}
      <div className="relative aspect-[16/9] overflow-hidden">
        <img 
          src={universe.cover_image || "https://static.prod-images.emergentagent.com/jobs/f60715c2-3b6b-4c99-a6c8-5c96b98e6cf9/images/53108f7d8ec9c28606e03e3c421e51fe4b80f13705cd9eeafc38c88182bd88ad.png"}
          alt={universe.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#030712] via-[#030712]/50 to-transparent" />
        
        {/* Category Badge */}
        <span className={`absolute top-4 right-4 px-3 py-1 text-xs font-semibold uppercase tracking-wider ${getCategoryBadge(universe.category)}`}>
          {universe.category}
        </span>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-yellow-500 transition-colors font-['Outfit']">
          {universe.name}
        </h3>
        <p className="text-slate-400 text-sm line-clamp-2 mb-4">
          {universe.description}
        </p>
        <div className="flex items-center justify-between text-xs text-slate-500">
          <span className="font-mono">{universe.formed_date}</span>
          <span>{universe.time_period}</span>
        </div>
      </div>
    </Link>
  );
};

export default UniverseCard;
